import React, { useEffect, useRef, useState } from "react";

// Libraries and Packages
import { cubicBezier, motion, useAnimation, useInView } from "framer-motion";

function AnimatedLetters({ text }) {
  const [letters, setLetters] = useState([]);

  useEffect(() => {
    setLetters(text.split(""));
  }, [text]);

  // Ref
  const refText = useRef(null);

  // Framer Motion
  const controlsAnimatedLetters = useAnimation();

  const isAnimatedLettersInView = useInView(refText, {
    once: false,
  });

  // Effect
  useEffect(() => {
    if (isAnimatedLettersInView) {
      controlsAnimatedLetters.start({
        opacity: 1,
        y: 0,
      });
    }
  }, [isAnimatedLettersInView, controlsAnimatedLetters]);

  return (
    <p className="animatedLetters" ref={refText}>
      {letters.map((letter, i) => {
        return (
          <motion.span
            key={i}
            style={{ display: "inline-block" }}
            initial={{ opacity: 0, y: 10 }}
            animate={controlsAnimatedLetters}
            transition={{
              duration: 0.5,
              delay: 0.5 + 0.1 * i,
              ease: cubicBezier[(0.6, 0.01, -0.05, 0.9)],
            }}
          >
            {letter}
          </motion.span>
        );
      })}
    </p>
  );
}

export default AnimatedLetters;
